import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { ReviewStore, ReviewState } from './review.store';

@Injectable()
export class ReviewQuery extends QueryEntity<ReviewState> {
  constructor(protected store: ReviewStore) {
    super(store);
  }
}
